//
//
//
//
//

export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  },
  created () {
    localStorage.setItem('school_source', 'v1') // 标注版本 旧版
    this.$setBaseURL('/api')
    this.callbackBackend()
  },
  methods: {
    // 判断用户菜单权限进行页面跳转
    isAuth () {
      this.$http({
        method: 'post',
        url: '/workorder/ordertype/menu'
      }).then(res => {
        if (res.result.length > 1) {
          if (this.getCookie('dmkj_flag') === '0') {
            this.$router.push({ path: '/schoollist', query: { type: 1 } })
          } else {
            let source = localStorage.getItem('school_source') || '' // 标注版本 新版
            if (source === 'v1') {
              this.$router.push({ path: '/todoPage' })
            } else if (source === 'v2') {
              this.$router.push({ path: '/v2todoPage' })
            }
          }
        } else {
          this.$http({
            method: 'post',
            url: '/report/isauth'
          }).then(res => {
            if (res.result) {
              if (this.getCookie('dmkj_flag') === '0') {
                this.$router.push({ path: '/schoollist', query: { type: 1 } })
              } else {
                this.$router.push({ path: '/dataCenter' })
              }
            } else {
              this.$router.push({ path: '/noauth' })
            }
          }).catch(error => {
            console.log(error)
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 回调后返回给后台code参数，判断用户是否登录后跳转
    callbackBackend () {
      var params = new URLSearchParams()
      params.append('code', this.getUrlPramas('code'))
      params.append('number', this.getUrlPramas('state'))
      this.$http({
        method: 'post',
        url: '/isauth',
        data: params
      }).then(res => {
        if (+res.code === 100) {
          if (res.result === 'user_login_not') {
            this.$router.push({ path: '/bindLogin' })
          } else if (res.result === 'request_param_error') { // code 失效
            let pageSource = localStorage.getItem('school_source') // 标注版本 新版
            // 正式环境
            const baseURL = pageSource === 'v2' ? 'https://wxschool.5idream.net/v2/api/index' : 'https://manager.5idream.net/api/index'
            window.location.href = baseURL
          } else {
            this.isAuth()
          }
        } else if (+res.code === -1005 || +res.code === 401) {
          this.$router.push({ path: '/bindLogin' })
        } else if (+res.code === -1003) {
          // 判断回退参数无效时退出页面，WeixinJSBridge关闭微信窗口
          // eslint-disable-next-line
          WeixinJSBridge.invoke('closeWindow', {}, function (res) {
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/HelloWorld.vue